import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_PAYMENT,
  CLEAR_PAYMENTS,
  FLAG_GETTING_PAYMENTS,
  FLAG_PAYMENT_ACTIVITY,
  GET_PAYMENT,
  GET_PAYMENTS,
} from '../../../actions/types/contract/Payment';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_PAYMENTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_PAYMENTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_PAYMENTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_PAYMENT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_PAYMENT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_PAYMENT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
